import { Component, computed, inject, OnInit, Signal } from '@angular/core';
import { Router } from '@angular/router';

import { ButtonComponent, IActivarTab, Status, TabsComponent } from '@webapp/ui';
import { ProspectsTableComponent } from '@webapp/prospects/ui/components/prospects-table.component.ts/prospects-table.component';
import { PaginationComponent } from '@webapp/core/ui/components/pagination/pagination.component';
import { IUserList, USER_ROLES } from '../../../interfaces/users.interface';
import { UsersStoreService } from '../../../store/users-store.service';
import { SearchUserComponent } from '../../components/search-users/search-users.component';
import { UsersTableSkeletonComponent } from '../../components/users-table-skeleton/users-table-skeleton.component';
import { UsersTableComponent } from '../../components/users-table/users-table.component';
import { AuthService } from '@webapp/auth/services/auth.service';

@Component({
	selector: 'app-users-page',
	imports: [
		UsersTableComponent,
		PaginationComponent,
		SearchUserComponent,
		TabsComponent,
		ProspectsTableComponent,
		UsersTableSkeletonComponent,
		ButtonComponent,
	],
	templateUrl: './users-page.component.html',
	styleUrl: './users-page.component.scss',
})
export class UsersPageComponent implements OnInit {
	usersStore = inject(UsersStoreService);
	router = inject(Router);
	private readonly authService = inject(AuthService);
	user = this.authService.user();
	Status = Status;

	paginationStore = this.usersStore.listStore.paginationStore;
	roles = [USER_ROLES.CLIENT, USER_ROLES.PROSPECT, USER_ROLES.AGENT, USER_ROLES.ADMIN]

	ngOnInit() {
		this.switchTab(this.activeTab());
		this.changePage();
		if (this.user?.role === USER_ROLES.ADMIN || this.user?.role === USER_ROLES.SUPERADMIN) {
			this.tabs.push('Productores')
		}
		if (this.user?.role === USER_ROLES.SUPERADMIN) {
			this.tabs.push('Administradores')
		}
	}

	;

	tabs: IActivarTab[] = ['Asegurados', 'Prospectos'];

	protected get isSuperAdmin(): boolean {
		return this.user?.role === USER_ROLES.SUPERADMIN;
	}

	protected goToCreateAdmin(): void {
		this.router.navigate(['usuarios', 'nuevo']);
	}

	get activeTab(): Signal<number> {
		return computed(() => {
			return this.usersStore.hasProspectFilter()() ? 1 : 0;
		});
	}

	changePage() {
		this.usersStore.listStore.fetch();
	}

	openDetail(row: IUserList) {
		const route = this.usersStore.hasProspectFilter()()
			? 'prospectos'
			: 'usuarios';
		this.router.navigate([route, row.id]);
	}

	loading() {
		return this.usersStore.listStore.select('loading')();
	}

	switchTab(tab: number) {
		this.usersStore.listStore.setFilters({ role: this.roles[tab] });
	}
}
